const INVOICE_STATUS_LABELS = {
  draft: 'Draft',
  open: 'Open',
  paid: 'Paid',
  uncollectible: 'Uncollectible',
  refunded: 'Refunded',
  partially_refunded: 'Partially refunded',
  void: 'Void',
};

export default function getInvoiceStatusLabel(status) {
  return INVOICE_STATUS_LABELS[status] || 'Unknown';
}
